// removed by extract-text-webpack-plugin
module.exports = {"container":"ClickableCell-container","clickableElement":"ClickableCell-clickableElement"};